<template>
<body id="page-top" class="member-page-body">
        <!-- Navigation-->
        <nav class="navbar navbar-expand-lg bg-secondary text-uppercase fixed-top" id="mainNav">
            <div class="container">
                <img class="navbar-brand" href="#page-top" src="../assets/philcare-logo.png"/>
                    <i class="fas fa-bars"></i>
            </div>
        </nav>
        <section class="page-section portfolio" id="portfolio">
            <div class="container cpt-10">
                <!-- Portfolio Grid Items-->
                <div class="row justify-content-center">
                    <!-- Portfolio Item 1-->
                    <!--<div class="col-md-3 col-lg-3 mb-5">
                        <div class="portfolio-item mx-auto" data-bs-toggle="modal" data-bs-target="#portfolioModal1">
                            <div class="d-flex align-items-center justify-content-center h-100 w-100">
                                <div class="portfolio-item-caption-content text-center text-white"><i class="fas fa-plus fa-3x"></i></div>
                            </div>
                            <a class="btn"><router-link to="/status"><img class="img-fluid" src="../assets/Membership-statues.png" alt="..." /></router-link></a>
                            <p class="h3">Membership Status, Plan and Benefits, Access to Hospital</p>
                        </div>
                    </div>-->
                    <!-- Portfolio Item 2-->
                    <!--<div class="col-md-3 col-lg-3 mb-5">
                        <div class="portfolio-item mx-auto" data-bs-toggle="modal" data-bs-target="#portfolioModal2">
                            <div class="d-flex align-items-center justify-content-center h-100 w-100">
                                <div class="portfolio-item-caption-content text-center text-white"><i class="fas fa-plus fa-3x"></i></div>
                            </div>
                            <a class="btn"><router-link to="/history"><img class="img-fluid" src="../assets/Availment-history.png" alt="..." /></router-link></a>
                            <p class="h3">Availment History</p>
                        </div>
                    </div>-->
                    <!-- Portfolio Item 2-->
                    <div class="col-md-3 col-lg-3 mb-5">
                        <div class="portfolio-item mx-auto" data-bs-toggle="modal" data-bs-target="#portfolioModal2">
                            <div class="d-flex align-items-center justify-content-center h-100 w-100">
                                <div class="portfolio-item-caption-content text-center text-white"><i class="fas fa-plus fa-3x"></i></div>
                            </div>
                            <a class="btn"><router-link to="/find-a-doctor"><img class="img-fluid" src="../assets/Find-a-Doctor.png" alt="..." /></router-link></a>
                            <p class="h3">Find a Provider</p>
                        </div>
                    </div>
                    <!-- Portfolio Item 2-->
                    <div v-if="allowLOAConsult" class="col-md-3 col-lg-3 mb-5">
                        <div class="portfolio-item mx-auto" data-bs-toggle="modal" data-bs-target="#portfolioModal2">
                            <div class="d-flex align-items-center justify-content-center h-100 w-100">
                                <div class="portfolio-item-caption-content text-center text-white"><i class="fas fa-plus fa-3x"></i></div>
                            </div>
                            <a class="btn"><router-link to="/loa-consultation"><img class="img-fluid" src="../assets/Loa-for-consultation.png" alt="..." /></router-link></a>
                            <p class="h3">LOA for Consultation</p>
                        </div>
                    </div>
                    <div v-if="allowLOALab" class="col-md-3 col-lg-3 mb-5">
                        <div class="portfolio-item mx-auto" data-bs-toggle="modal" data-bs-target="#portfolioModal1">
                            <div class="d-flex align-items-center justify-content-center h-100 w-100">
                                <div class="portfolio-item-caption-content text-center text-white"><i class="fas fa-plus fa-3x"></i></div>
                            </div>
                            <a class="btn"><router-link to="/loa-lab"><img class="img-fluid" src="../assets/Loa-for-laboratory-test.png" alt="..." /></router-link></a>
                            <p class="h3">LOA for Laboratory Test/ Procedure</p>
                        </div>
                    </div>
                     <!-- Portfolio Item 2-->
                     <div class="col-md-3 col-lg-3 mb-5">
                        <div class="portfolio-item mx-auto" data-bs-toggle="modal" data-bs-target="#portfolioModal2">
                            <div class="d-flex align-items-center justify-content-center h-100 w-100">
                                <div class="portfolio-item-caption-content text-center text-white"><i class="fas fa-plus fa-3x"></i></div>
                            </div>
                            <a class="btn"><router-link to="/loa-prev"><img class="img-fluid" src="../assets/Loa-Preview.png" alt="..." /></router-link></a>
                            <p class="h3">LOA Preview</p>
                        </div>
                    </div>
                    
                </div>
              
                <div class="col-md-12">
                    <button @click='logOut' class="btn btn-primary btn-lg exit-btn">EXIT</button>
                </div>
            </div>
        </section>
</body>
</template>

<script>
export default {
  name: 'PhilLogin',
  props: {
    certNo: String
  },
  data() {
    return {
      allowLOAConsult: false,
      allowLOALab: false
    };
  },
  mounted() {
      //localStorage.removeItem('CertNo');
      if (localStorage.getItem('CertNo') === null) {
          this.$router.push('/login');
      }
    
     this.allowLOAConsult = localStorage.getItem('allowLOAConsult') === '1';
     this.allowLOALab = localStorage.getItem('allowLOALab') === '1';


  },
  methods: {
        logOut() {
        localStorage.removeItem('CertNo');
        localStorage.removeItem('allowLOAConsult');
        localStorage.removeItem('allowLOALab');
        this.$router.push('/login');

    }
  }
}


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
